export function u8aToHex(array) {
    const results = [];
    array.forEach((arrayByte) => {
        results.push(arrayByte.toString(16).replace(/^([\da-f])$/, '0$1'));
    });
    return results.join('');
}
export function hexToU8a(hexstring) {
    let array;
    let i;
    let j = 0;
    let k;
    let ref;
    if (hexstring.length % 2 === 1) {
        hexstring = '0' + hexstring;
    }
    array = new Uint8Array(hexstring.length / 2);
    for (i = k = 0, ref = hexstring.length; k <= ref; i = k += 2) {
        array[j++] = parseInt(hexstring.substr(i, 2), 16);
    }
    return array;
}
export function u8aToBase64(array) {
    return btoa(Array.from(array, (byte) => String.fromCharCode(byte)).join(''));
}
export function base64ToU8a(base64String) {
    return Uint8Array.from(atob(base64String), (char) => char.charCodeAt(0));
}
export function randomString(length = 32, chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') {
    let str = '';
    for (let i = 0; i < length; i++) {
        str += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return str;
}
export function stringToUtf8a(str) {
    var out = [], p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (((c & 0xFC00) == 0xD800) && (i + 1) < str.length &&
            ((str.charCodeAt(i + 1) & 0xFC00) == 0xDC00)) {
            c = 0x10000 + ((c & 0x03FF) << 10) + (str.charCodeAt(++i) & 0x03FF);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return Uint8Array.from(out);
}
export function utf8aToString(bytes) {
    var out = [], pos = 0, c = 0;
    while (pos < bytes.length) {
        var c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        }
        else if (c1 > 239 && c1 < 365) {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xD800 + (u >> 10));
            out[c++] = String.fromCharCode(0xDC00 + (u & 1023));
        }
        else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
}
export function filter(obj, callback) {
    if (obj instanceof Array) {
        return obj.filter(callback);
    }
    else {
        const out = {};
        for (const key in Object.keys(obj)) {
            const value = obj[key];
            if (callback(value)) {
                out[key] = value;
            }
        }
        return out;
    }
}
export function isString(val) {
    return typeof val === 'string' || val instanceof String;
}
export function supportsPassive() {
    let support = false;
    try {
        const opts = Object.defineProperty({}, 'passive', {
            get: () => support = true,
        });
        window.addEventListener('test', null, opts);
    }
    catch (e) { }
    return support;
}
export function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
export function msgpackVisualizer(array) {
    return 'https://msgpack.dbrgn.ch#base64=' + encodeURIComponent(u8aToBase64(array));
}
export function hasFeature(contactReceiver, feature, log) {
    if (contactReceiver !== undefined) {
        if (contactReceiver.featureMask === 0) {
            log.warn(`Contact receiver with id ${contactReceiver.id} has featureMask 0`);
            return false;
        }
        if (feature === 0) {
            return true;
        }
        return (contactReceiver.featureMask & feature) !== 0;
    }
    log.warn('Cannot check featureMask of an undefined contact receiver');
    return false;
}
export function bufferToUrl(buffer, mimeType, log) {
    switch (mimeType) {
        case 'image/jpg':
        case 'image/jpeg':
        case 'image/png':
        case 'image/webp':
        case 'image/gif':
        case 'audio/mp4':
        case 'audio/m4a':
        case 'audio/x-m4a':
        case 'audio/aac':
        case 'audio/ogg':
        case 'audio/webm':
            break;
        default:
            const fallbackMimeType = 'image/jpeg';
            log.warn(`Unknown mimeType "${mimeType}", falling back to "${fallbackMimeType}"`);
            mimeType = fallbackMimeType;
            break;
    }
    return 'data:' + mimeType + ';base64,' + u8aToBase64(new Uint8Array(buffer));
}
export function arrayToBuffer(array) {
    if (array.byteOffset === 0 && array.byteLength === array.buffer.byteLength) {
        return array.buffer;
    }
    return array.buffer.slice(array.byteOffset, array.byteOffset + array.byteLength);
}
export function hasValue(val) {
    return val !== null && val !== undefined;
}
export function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
export function arraysAreEqual(a1, a2) {
    if (a1.length !== a2.length) {
        return false;
    }
    for (let i = 0; i < a1.length; i++) {
        if (a1[i] !== a2[i]) {
            return false;
        }
    }
    return true;
}
export function isActionTrigger(ev) {
    if (ev.key === undefined) {
        return false;
    }
    switch (ev.key) {
        case 'Enter':
        case ' ':
            return true;
        default:
            return false;
    }
}
export function copyShallow(object) {
    return Object.assign({}, object);
}
export function copyDeepOrReference(value) {
    if (value === null || value === undefined) {
        return value;
    }
    if (value.constructor === Object) {
        const object = {};
        for (const [k, v] of Object.entries(value)) {
            object[k] = copyDeepOrReference(v);
        }
        return object;
    }
    if (value instanceof Array) {
        return value.map((item) => copyDeepOrReference(item));
    }
    if (value instanceof ArrayBuffer) {
        return value.slice(0);
    }
    if (value instanceof Uint8Array) {
        const buffer = value.buffer.slice(0);
        return new Uint8Array(buffer, value.byteOffset, value.byteLength);
    }
    return value;
}
export function replaceWhitespace(text) {
    return text
        .replace(/ /g, '&nbsp;')
        .replace(/\t/, '&nbsp;&nbsp;');
}
export function firefoxWorkaroundPdfDownload(mimetype) {
    const uagent = window.navigator.userAgent.toLowerCase();
    const isFirefox = /mozilla/.test(uagent) && /firefox/.test(uagent);
    if (isFirefox && mimetype === 'application/pdf') {
        return 'application/octet-stream';
    }
    return mimetype;
}
